<template>
  <div class="esp_login">
    <!-- logo -->
    <div class="esp-logo">USRMS系统</div>

    <!-- 表单 -->
    <div class="esp-form">
      <div class="esp-form-title">
        <span>用户登录</span>
      </div>
      <div class="esp-form-name">
        <el-input v-model="formData.logincode" size="medium" placeholder="用户名"></el-input>
      </div>
      <div class="esp-form-pwd">
        <el-input v-model="formData.pwd" size="medium" show-password placeholder="密码"></el-input>
      </div>
      <div class="esp-form-forget clearfix">
        <div>
          <el-checkbox v-model="checked" true-label="Y" false-label="N">
            <span>记住密码</span>
          </el-checkbox>
        </div>
        <div>忘记密码？</div>
      </div>
      <div class="esp-form-botton">
        <el-button type="primary" @click="doLogin" size="medium" round>
          <span>登 录</span>
        </el-button>
      </div>
      <div class="esp-form-copyright">
        <span>©2022 上海用诚计算机技术有限公司</span>
      </div>
    </div>

    <!-- 页脚描述 -->
    <div class="esp-footer-memo">
      <span>版权归我司所有，盗取将追究相关法律责任！</span>
    </div>
  </div>
</template>


<script>
  import * as auth from "@/api/platform/auth";
  import * as cache from "@/utils/cache"

  export default {
    name: "Login",
    data() {
      return {
        checked: "Y",

        formData: {
          logincode: "",
          pwd: ""
        }
      }
    },
    methods: {
      // 登录
      doLogin: function () {
        if (!this.formData.logincode) {
          this.$message({type: "error", message: "请填写用户名"});
          return;
        }

        if (!this.formData.pwd) {
          this.$message({type: "error", message: "请填写密码"});
          return;
        }

        auth.regToken(this.formData).then(result => {
          cache.regAuth(result.data)
          this.$router.push({path: "/index"});
        }).catch(error => {
        });

      }
    }
  }
</script>


<style scoped>
  /* 背景 */
  .esp_login {
    width: 100%;
    height: 100%;
    font-family: Microsoft YaHei;
    position: relative;
    background: url("../../../static/images/login/login_bg.jpg") no-repeat center center;
    background-size: 100% 100%;
  }

  /* logo */
  .esp_login .esp-logo {
    width: 25%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -15% 0px 0px -35.5%;
    font-size: 0.55rem;
    font-weight: bold;
    color: #ffffff;
  }

  /* 表单 */
  .esp_login .esp-form {
    width: 400px;
    height: 430px;
    background-color: #ffffff;
    border-radius: 10px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -14.5% 0px 0px 11%;
  }

  .esp_login .esp-form > div {
    margin: 30px 30px 0px 30px;
  }

  .esp_login .esp-form .esp-form-title {
    font-size: 24px;
    font-weight: bold;
    color: #2356dd;
  }

  .esp_login .esp-form .esp-form-forget {
    margin-top: 20px;
  }

  .esp_login .esp-form .esp-form-forget > div:first-of-type {
    float: left;
    cursor: pointer;
    font-size: 14px;
  }

  .esp_login .esp-form .esp-form-forget > div:last-of-type {
    float: right;
    cursor: pointer;
    color: #606266;
    font-size: 14px;
  }

  .esp_login .esp-form .esp-form-botton {
    margin-top: 50px;
    font-size: 12px;
  }

  .esp_login .esp-form .esp-form-copyright {
    font-size: 16px;
    color: #b3b3b3;
  }

  /* 页脚 */
  .esp_login .esp-footer-memo {
    width: 100%;
    height: 40px;
    text-align: center;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.4);
    position: absolute;
    left: 0px;
    bottom: 0px;
  }

  /* 清除浮动 */
  .esp_login .clearfix:after {
    content: "";
    display: block;
    clear: both;
  }
</style>


<style>
  .esp_login .esp-form .esp-form-name,
  .esp_login .esp-form .esp-form-pwd {
    line-height: 0px;
  }

  .esp_login .esp-form .esp-form-name .el-input__inner,
  .esp_login .esp-form .esp-form-pwd .el-input__inner {
    border-radius: 0px !important;
    height: 45px;
    line-height: 45px;
    background-color: #ffffff !important;
  }

  .esp_login .el-input--medium .el-input__icon {
    line-height: 45px;
  }

  .esp_login .esp-form .esp-form-botton .el-button {
    width: 100%;
    height: 45px;
    border-radius: 22.5px;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue